import { useApolloClient } from '@apollo/client';
import { useNavigation } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';
import { Button, Meta } from 'aimo-ui';
import { showToast } from 'components/common/CustomToast';
import { START_ANPR_PARKING } from 'graphql/mutations/readLaneStartAnpr';
import useSelectedParkingVehicle from 'hooks/useSelectedParkingVehicle';
import { t } from 'i18next';
import React, { useState } from 'react';
import { useParkingStore } from 'stores/parkingStore';
import styled from 'styled-components/native';
import { StyledWrapper } from 'styles/ContainerStyles';
import { RootStackParamList } from 'types/navigation';
import { useUiStore } from 'stores/uiStore';

const FlexContainer = styled.View`
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
  gap: 14px;
`;

const ButtonContainer = styled.View`
  flex-direction: column;
  gap: 20px;
`;

const WeightedMeta = styled(Meta)`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.gray300};
`;

const ContentAndButtonWrapper = styled.View`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const OpenBarrierManually = () => {
  const { navigate: navigateRoot } =
    useNavigation<StackNavigationProp<RootStackParamList>>();
  const client = useApolloClient();

  const input = useParkingStore((state) => state.anprParkingInput);

  const [isOpeningBarrier, setIsOpeningBarrier] = useState(false);
  const vehicle = useSelectedParkingVehicle(false);
  const licensePlate = vehicle?.licensePlate?.plateText;

  const anprParkingInputValues = {
    ...input,
  };

  const navigateToParkScreen = () => {
    navigateRoot('mainTabs', {
      screen: 'parkScreen',
      params: { screen: 'park' },
    });
  };

  const handleStartAnprParking = async () => {
    setIsOpeningBarrier(true);
    try {
      await client.mutate({
        mutation: START_ANPR_PARKING,
        variables: {
          input: {
            confidence: anprParkingInputValues.confidence,
            laneGroupId: anprParkingInputValues.laneGroupId,
            laneId: anprParkingInputValues.laneId,
            systemId: anprParkingInputValues.systemId,
            licensePlate: licensePlate,
          },
        },
        fetchPolicy: 'network-only',
      });
      useUiStore.getState().setSheetModal('');
      navigateToParkScreen();
    } catch (error) {
      showToast('error.parkingStartedFailed', 'error');
      console.error('Error starting ANPR parking:', error);
      useUiStore.getState().setSheetModal('');
    } finally {
      setIsOpeningBarrier(false);
    }
  };

  const handleBack = () => {
    useUiStore.getState().setSheetModal('');
  };

  return (
    <StyledWrapper mt={12}>
      <ContentAndButtonWrapper>
        <FlexContainer>
          <WeightedMeta>{t('parking.anprOpenBarrier')}</WeightedMeta>
          <WeightedMeta>{t('parking.anprstartSession')}</WeightedMeta>
        </FlexContainer>
        <ButtonContainer>
          <Button
            text={
              isOpeningBarrier
                ? t('button.openingBarrierANPR')
                : t('button.openBarrierANPR')
            }
            size="l"
            testID="close"
            onPress={handleStartAnprParking}
            disabled={isOpeningBarrier}
          />
          <Button
            text={t('button.cancel')}
            buttonType="tertiary"
            size="l"
            testID="close"
            onPress={handleBack}
          />
        </ButtonContainer>
      </ContentAndButtonWrapper>
    </StyledWrapper>
  );
};
export default OpenBarrierManually;
